<template>
    <div class="header" :style="{ backgroundColor: $store.state.themeColor }">
        <!-- 折叠按钮 -->
        <div class="collapse-btn" @click="collapseChage">
            <i v-if="!collapse" class="el-icon-s-fold"></i>
            <i v-else class="el-icon-s-unfold"></i>
        </div>
        <div class="logo">
            <!-- <img class="logoImg" v-if="conpamyLogo" :src="conpamyLogo" alt /> -->
            <div>{{ companyName }}</div>
        </div>
        <div class="logo notify" v-if="notifyMessage">
            <i class="el-icon-chat-line-round"></i>
            {{ notifyMessage }}
        </div>
        <div class="header-right">
            <div class="header-user-con">
                <!-- <el-button plain @click="reloadOpt">强制刷新</el-button> -->

                <el-dropdown class="user-name" placement="bottom">
                    <i class="newIcon iconfont icon-gongzhonghao"></i>
                    <el-dropdown-menu slot="dropdown">
                        <el-image style="width: 150px; height: 150px"
                            src="https://iot.sundayTek.com/imgs/sundayTekAccess.jpg" fit="cover"></el-image>
                    </el-dropdown-menu>
                </el-dropdown>

                <el-dropdown class="user-name" placement="bottom">
                    <i class="newIcon iconfont icon-xiaochengxu"></i>
                    <el-dropdown-menu slot="dropdown">
                        <el-image style="width: 150px; height: 150px"
                            src="https://iot.sundayTek.com/imgs/sundatekApplet.jpg" fit="cover"></el-image>
                    </el-dropdown-menu>
                </el-dropdown>

                <!-- 全屏显示 -->
                <div class="btn-fullscreen" @click="handleFullScreen">
                    <el-tooltip effect="dark" :content="fullscreen ? `取消全屏` : `全屏`" placement="bottom">
                        <i class="el-icon-rank"></i>
                    </el-tooltip>
                </div>

                <!-- 跳转到大屏 -->
                <div class="btn-bell">
                    <el-tooltip effect="dark" content="跳转到监控界面" placement="bottom">
                        <router-link to="/ANewMaxWeb">
                            <i class="el-icon-data-line" style="color: #fff; margin: 0 10px"></i>
                        </router-link>
                    </el-tooltip>
                </div>

                <!-- 用户头像 -->
                <div class="user-avator">
                    <img :src="userImg" />
                </div>
                <!-- 用户名下拉菜单 -->
                <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{ username }}
                        <i class="el-icon-caret-bottom"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item divided command="changePwd">修改密码</el-dropdown-item>

                        <el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="400px">
            <el-form>
                <el-form-item label="原密码" label-width="120px">
                    <el-input class="inputWidth" v-model="changePwdForm.oldPwd" type="password"
                        :show-password="true"></el-input>
                </el-form-item>
                <el-form-item label="新密码" label-width="120px">
                    <el-input class="inputWidth" v-model="changePwdForm.newPwd1" type="password"
                        :show-password="true"></el-input>
                </el-form-item>
                <el-form-item label="新密码" label-width="120px">
                    <el-input class="inputWidth" v-model="changePwdForm.newPwd2" type="password"
                        :show-password="true"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveChangePwd">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import bus from '../common/bus';
import { Notification } from '../../api/index.js';
import { ChangeUserPwd } from '../../api';

export default {
    data() {
        return {
            // 修改密码表单数据
            changePwdForm: {
                oldPwd: '',
                newPwd1: '',
                newPwd2: ''
            },
            // 打开修改密码界面
            dialogFormVisible: false,
            headerBgc: `backgroundColor: ${this.$store.state.themeColor};`,
            conpamyLogo: JSON.parse(localStorage.getItem('companyInfo')).logo
                ? JSON.parse(localStorage.getItem('companyInfo')).logo
                : false,
            collapse: false,
            fullscreen: false,
            userImg: JSON.parse(localStorage.getItem('userinfo')).imgSrc
                ? JSON.parse(localStorage.getItem('userinfo')).imgSrc
                : 'https://iot.sundaytek.com/imgs/applet/userImgNone.png',
            name: '',
            companyname: '',
            message: 2,
            notifyMessage: ''
        };
    },
    computed: {
        username() {
            let username = JSON.parse(localStorage.getItem('userinfo')).name;
            return username ? username : this.name;
        },
        companyName() {
            let companyName = JSON.parse(localStorage.getItem('companyInfo')).companyName;
            return companyName ? companyName : this.companyname;
        }
    },
    methods: {
        // 确定修改密码
        async saveChangePwd() {
            // 判断输入是否为空
            let { oldPwd, newPwd1, newPwd2 } = this.changePwdForm;
            oldPwd = oldPwd.trim();
            newPwd1 = newPwd1.trim();
            newPwd2 = newPwd2.trim();
            if (oldPwd == '' || newPwd1 == '' || newPwd2 == '') {
                this.$message.warning('请检查输入');
                return;
            }
            if (newPwd1 !== newPwd2) {
                this.$message.warning('请检查输入');
                return;
            }
            let that = this;

            this.$confirm('确认修改密码吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    console.log('既然怒');
                    const result = await ChangeUserPwd({ id: JSON.parse(localStorage.getItem('userinfo')).id, password: newPwd2, oldPwd: oldPwd });
                    console.log(result);
                    if (result.code !== 200) {
                        return;
                    }
                    that.$message.success('修改成功');
                    localStorage.clear();
                    that.$router.push('login');
                })
                .catch((err) => {
                    console.log(err);
                });

            console.log(oldPwd, newPwd1, newPwd2);
        },
        // 获取通知消息
        async getNotif() {
            const result = await Notification();
            console.log('result');
            console.log(result);
            if (result.code !== 200) {
                return;
            }
            this.notifyMessage = result.data;
        },

        // 刷新界面
        reloadOpt() {
            window.location.reload();
        },
        // 用户名下拉菜单选择事件
        handleCommand(command) {
            if (command == 'loginout') {
                localStorage.removeItem('ms_username');
                this.$router.push('/login');
            }
            if (command == 'changePwd') {
                this.dialogFormVisible = true
            }
        },
        // 侧边栏折叠
        collapseChage() {
            this.collapse = !this.collapse;
            bus.$emit('collapse', this.collapse);
        },
        // 全屏事件
        handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        }
    },
    mounted() {
        if (document.body.clientWidth < 1500) {
            this.collapseChage();
        }
        this.getNotif();
    }
};
</script>
<style scoped>
.header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    font-size: 22px;
    color: #fff;
    border-bottom: 1px solid #393943;
}

.collapse-btn {
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 70px;
}

.header .logo {
    float: left;
    width: 300px;
    line-height: 70px;
    margin-left: 10px;
    display: flex;
    align-items: center;
}

.logoImg {
    height: 60px;
    margin-right: 10px;
}

.header .notify {
    max-width: max-content;
    width: auto;
    font-size: 14px;
}

.header-right {
    float: right;
    padding-right: 50px;
}

.header-user-con {
    display: flex;
    height: 70px;
    align-items: center;
}

.btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 24px;
}

.btn-bell,
.btn-fullscreen {
    position: relative;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
}

.btn-bell-badge {
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #fff;
}

.btn-bell .el-icon-bell {
    color: #fff;
}

.user-name {
    color: #fff;
    margin-left: 10px;
}

.user-avator {
    margin-left: 20px;
}

.user-avator img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.el-dropdown-link {
    color: #fff;
    cursor: pointer;
}

.el-dropdown-menu__item {
    text-align: center;
}

.newIcon {
    font-size: 22px;
    margin-right: 10px;
}
</style>
